import { Controller } from "stimulus";
import Turbolinks from "turbolinks";

export default class extends Controller
{
    static targets = ["submit", "search", "xmitControl", "xmitSearch", "clear", "loading", "plainInput", "dropdownInput"];

    SITE_GROUPS = [];
    SITE_TYPES = [];
    REGIONS = [];
    TIME_ZONES = [];

    connect()
    {   
        this.submitTarget.addEventListener("click", e =>
        {
            if(!this.validate(this.element)) e.preventDefault();
        });

        this.searchTarget.addEventListener("click", e =>
        {
            this.searchTarget.classList.add("hidden");
            this.xmitControlTarget.classList.remove("hidden");
            this.clearTarget.classList.remove("hidden");

            if(this.plainInputTarget.value != "")
            {
                this.plainInputTarget.classList.add("hidden");
                this.dropdownInputTarget.classList.remove("hidden");
            }
        });

        this.clearTarget.addEventListener("click", e =>
        {
            this.searchTarget.classList.remove("hidden");
            this.xmitControlTarget.classList.add("hidden");
            this.clearTarget.classList.add("hidden");

            this.plainInputTarget.value = this.dropdownInputTarget.querySelector("input").value;
            this.plainInputTarget.classList.remove("hidden");
            this.dropdownInputTarget.classList.add("hidden");
        })

        this.xmitSearchTarget.addEventListener("start-loading", e =>
        {
            this.clearTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");
        })

        this.xmitSearchTarget.addEventListener("stop-loading", e =>
        {
            this.clearTarget.classList.remove("hidden");
            this.loadingTarget.classList.add("hidden");
        })

        this.xmitSearchTarget.addEventListener("load-xmits", e =>
        {
            console.log(e);

            this.plainInputTarget.name = "";
            this.plainInputTarget.classList.add("hidden");
            this.dropdownInputTarget.classList.remove("hidden");
            this.dropdownInputTarget.querySelectorAll("input")[0].name = "transmitter_code";

            let fillDropdownEvent = new CustomEvent("fill-dropdown",{ detail: {data: e.detail, type: "single"}});
            this.dropdownInputTarget.dispatchEvent(fillDropdownEvent);
        })
    }

    validate(form)
    {
        let pass = true;

        let requiredFields = Array.from(form.querySelectorAll(`input`)).filter(x => x.required && x.dataset.validation);

        for(let i = 0; i<requiredFields.length; i++)
        {
            let field = requiredFields[i];
            if(!field.value)
            {
                let message = field.dataset["validation"];
                let event = new CustomEvent("show-toast", { detail: "An error occurred:\n"+message });
                window.dispatchEvent(event);

                pass = false;
                break;
            }
        }

        return pass;
    }

    handleEdit(event)
    {
        if (event.detail[0] && !event.detail[0].success)
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
        else
        {
            let { active_dev_num, site_num } = event.detail[0];

            const success = new CustomEvent("show-toast", { detail: "Site successfully created!" })
            window.dispatchEvent(success)
            Turbolinks.visit(window.App.prefixedUrl(`/sites/${site_num}?active_dev_num=${active_dev_num}`))
        }
    }

}